import moment from 'moment';
import 'moment/locale/es';

// Textos de una tarjeta del portal, al estilo "Llega mañana" / "Entregado el 29 de octubre".

const dayPhrase = (date) => {
    const m = moment(date).locale('es');
    const today = moment().startOf('day');
    const diff = m.clone().startOf('day').diff(today, 'days');
    if (diff === 0) return 'hoy';
    if (diff === 1) return 'mañana';
    if (diff === -1) return 'ayer';
    if (diff > 1 && diff < 7) return `el ${m.format('dddd')}`;
    return `el ${m.format('D [de] MMMM')}`;
};

export const headline = (card) => {
    if (!card) return '';
    if (card.cancelled) return 'Pedido cancelado';
    if (card.step === 3) {
        const when = card.delivered_at || card.eta;
        return when ? `Entregado ${dayPhrase(when)}` : 'Entregado';
    }
    if (!card.eta) return card.step === 0 ? 'Recibimos tu pedido' : 'Pronto te contamos cuándo llega';

    // Una fecha que ya paso sin entrega no es "Llega ayer": se dice como lo que es.
    const isPast = moment(card.eta).isBefore(moment().startOf('day'));
    return isPast ? `Despacho programado ${dayPhrase(card.eta)}` : `Llega ${dayPhrase(card.eta)}`;
};

// La frase grande del detalle, sobre la linea de tiempo.
export const stepTitle = (card) => {
    if (!card) return '';
    if (card.cancelled) return 'Tu pedido fue cancelado';
    switch (card.step) {
        case 0: return 'Recibimos tu pedido';
        case 1: return 'Estamos preparando tu pedido';
        case 2: return 'Tu pedido va en camino';
        default: return card.partial ? 'Entregamos parte de tu pedido' : 'Entregamos tu pedido';
    }
};

export const statusColor = (card) => {
    if (card?.cancelled) return 'error.main';
    if (card?.partial) return 'warning.main';
    return 'success.main';
};

export const formatDateTime = (date) => (date ? moment(date).locale('es').format('D [de] MMMM YYYY, HH:mm') : '');
